import React from 'react';

import { Badge, Button, Divider, Group, Modal, Stack, Text, Title } from '@mantine/core';
import WorkoutRichTextEditor from 'components/workout-program/WorkoutRichTextEditor';
import { WorkoutMovementList } from 'types';
import { SCORE_TYPE_LABEL_MAP, ScoreTypeEnum } from 'types/enums';

interface IModalBenchmarkViewProps {
  opened: boolean;
  closeHandler: () => void;
  benchmark?: WorkoutMovementList;
  onEdit?: () => void;
  permission?: boolean;
}

const ModalBenchmarkView = ({
  opened,
  closeHandler,
  benchmark,
  onEdit,
  permission = true,
}: IModalBenchmarkViewProps): JSX.Element => {
  if (!benchmark) return <></>;

  const isDefault = benchmark.source === 'Default';
  const hasDescription =
    !!benchmark.description && benchmark.description.replace(/<[^>]*>/g, '').trim() !== '';

  return (
    <Modal
      centered
      opened={opened}
      onClose={closeHandler}
      title={<Title order={4}>{benchmark.name}</Title>}
      size='lg'
    >
      <Divider mb='lg' />
      <Stack spacing='lg'>
        <div>
          <Text size='sm' color='dimmed' weight={500}>
            Benchmark Name
          </Text>
          <Text size='md' mt={4}>
            {benchmark.name}
          </Text>
        </div>

        <div>
          <Text size='sm' color='dimmed' weight={500} mb={4}>
            Description
          </Text>
          {hasDescription ? (
            <WorkoutRichTextEditor
              value={benchmark.description ?? ''}
              onChange={() => undefined}
              editable={false}
            />
          ) : (
            <Text size='sm' color='dimmed' italic>
              No description provided
            </Text>
          )}
        </div>

        <div>
          <Text size='sm' color='dimmed' weight={500}>
            Scoring Type
          </Text>
          {benchmark.defaultScoreType ? (
            <Text size='md' mt={4}>
              {SCORE_TYPE_LABEL_MAP[benchmark.defaultScoreType as ScoreTypeEnum]}
            </Text>
          ) : (
            <Text size='sm' color='dimmed' mt={4} italic>
              Not set
            </Text>
          )}
        </div>

        <div>
          <Text size='sm' color='dimmed' weight={500}>
            Source
          </Text>
          <Badge color={isDefault ? 'gray' : 'blue'} variant='filled' size='lg' mt={4}>
            {benchmark.source}
          </Badge>
        </div>

        <Group position='right' mt='md'>
          <Button variant='subtle' onClick={closeHandler}>
            Close
          </Button>
          {onEdit && (
            <Button onClick={onEdit} disabled={!permission}>
              Edit
            </Button>
          )}
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalBenchmarkView;
